import { getNewWidgetDataAfterMoveFormTempToNewId } from "Utils/widgetsUtils"

import {
  getNewStateOnFilterValueSelection,
  getNewStateOnWidgetDataSuccess,
} from "Containers/Page/page.utils.js"

import {
  RESET_PAGE_PROPS,
  //DICTIONARY
  SET_DICTIONARY_WIDGET_TEMP_NEW_ID,
  CLEAR_DICTIONARY,
  UPDATE_PAGE_SUCCESS,
  UPDATE_ONE_WIDGET_SUCCESS,
  GET_PAGE_BY_ID_SUCCESS,
  GET_WIDGETS_SUCCESS,
  SELECT_COMPARISON_VALUE,
  REMOVE_COMPARISON_VALUE,
  CLEAR_COMPARISON_VALUES,
  SET_FILTER_VALUE,
  CLEAR_VALUE_FILTER_SELECTED,
  REMOVE_SELECTED_VALUE,
  GET_WIDGET_DATA_SUCCESS,
  GET_FIELD_INFOS_SUCCESS,
  GET_PAGE_PERMISSION_SUCCESS,
  UPDATE_PAGE_IS_PUBLIC_SUCCESS,
  CLONE_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT,
  CLONE_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED,
  CLONE_FILTER_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT,
  CLONE_FILTER_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED,
  // Uploads
  UPLOAD_WIDGET_IMAGE_PAGE_STATUS_RESET,
  UPLOAD_WIDGET_IMAGE_PAGE_STATUS_PENDING,
  UPLOAD_WIDGET_IMAGE_PAGE_STATUS_SUCCESS,
  //OTHER
  SET_WIDGET_REQUEST_STATUS,
  SET_LAST_WIDGET_SAVED,
  CHANGE_SAVING_PAGE_STATUS,
  // DRILL DOWN
  SET_DRILLDOWN_ENABLED,
} from "./constants"

const initialState = {
  drillDownEnabled: true,
  actualPage: {
    page: {},
    widgets: [],
    widgetsData: {
      widgetBeingEdited: {},
    },
    widgetFilterData: {
      widgetBeingEdited: {},
    },
    widgetsRequestStatus: {
      widgetBeingEdited: "",
    },
    pagePermissions: [],
    valueFilterSelected: {},
    comparisonValues: {},
    dictionary: {},
    widgetImageData: {
      widgetBeingEdited: {
        uploadStatus: "NONE",
      },
    },
    pageInformations: {
      savingStatus: "NONE",
    },
    lastWidgetSave: {
      widgetId: "",
      timestamp: 0,
    },
  },
}

function pageReducer(state = initialState, { type, payload }) {
  switch (type) {
    case SET_DICTIONARY_WIDGET_TEMP_NEW_ID:
      var dictionary = payload
      var actualWidgetsData = { ...state.actualPage.widgetsData }
      var newWidgetsData = getNewWidgetDataAfterMoveFormTempToNewId(actualWidgetsData, dictionary)

      var actualFilterWidgetsData = { ...state.actualPage.widgetFilterData }
      var newFilterWidgetsData = getNewWidgetDataAfterMoveFormTempToNewId(
        actualFilterWidgetsData,
        dictionary
      )

      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          dictionary: dictionary,
          widgetsData: newWidgetsData,
          widgetFilterData: newFilterWidgetsData,
        },
      }
    case CLEAR_DICTIONARY:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          dictionary: {},
        },
      }
    case UPDATE_PAGE_SUCCESS:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          page: payload,
        },
      }
    case UPDATE_ONE_WIDGET_SUCCESS: {
      const updatedWidgetId = payload?._id?.$oid
      if (!updatedWidgetId) return state
      const currentWidgets = state.actualPage.widgets || []
      const existingIndex = currentWidgets.findIndex(w => w?._id?.$oid === updatedWidgetId)
      const nextWidgets =
        existingIndex >= 0
          ? currentWidgets.map((w, i) => (i === existingIndex ? { ...w, ...payload } : w))
          : [...currentWidgets, payload]
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgets: nextWidgets,
        },
      }
    }
    case GET_PAGE_BY_ID_SUCCESS:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          page: payload,
        },
      }
    case SELECT_COMPARISON_VALUE:
      var { widgetId, ...restPayload } = payload
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          comparisonValues: {
            ...state.actualPage.comparisonValues,
            [widgetId]: {
              ...restPayload,
            },
          },
        },
      }
    case REMOVE_COMPARISON_VALUE:
      var newComparisonValues = {
        ...state.actualPage.comparisonValues,
      }

      var comparisonValuesToReturn = newComparisonValues
      var widgetId = payload
      if (newComparisonValues.hasOwnProperty(widgetId)) {
        var { [widgetId]: elt, ...comparisonValuesToReturn } = newComparisonValues
      }
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          comparisonValues: comparisonValuesToReturn,
        },
      }
    case CLEAR_COMPARISON_VALUES:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          comparisonValues: {},
        },
      }
    // DEPRECATED: Filter state moved to FilterStore (CustomEvents)
    // case SET_FILTER_VALUE:
    // case CLEAR_VALUE_FILTER_SELECTED:
    // case REMOVE_SELECTED_VALUE:
    case GET_PAGE_PERMISSION_SUCCESS:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          pagePermissions: payload,
        },
      }
    case UPDATE_PAGE_IS_PUBLIC_SUCCESS:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          page: {
            ...state.actualPage.page,
            isPublic: payload.isPublic,
          },
        },
      }
    case GET_WIDGETS_SUCCESS:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgets: payload,
        },
      }
    case GET_WIDGETS_SUCCESS:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgets: payload,
        },
      }
    case CLONE_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgetsData: {
            ...state.actualPage.widgetsData,
            [payload.id]: {
              ...state.actualPage.widgetsData.widgetBeingEdited,
            },
            widgetBeingEdited: {},
          },
        },
      }
    case CLONE_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED:
      var data = state?.actualPage?.widgetsData?.[payload.id]
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgetsData: {
            ...state.actualPage.widgetsData,
            widgetBeingEdited: data ? { ...data } : {},
          },
        },
      }
    case CLONE_FILTER_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgetFilterData: {
            ...state.actualPage.widgetFilterData,
            [payload.id]: {
              ...state.actualPage.widgetFilterData.widgetBeingEdited,
            },
            widgetBeingEdited: {},
          },
        },
      }
    case CLONE_FILTER_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED:
      var filterData = state?.actualPage?.widgetFilterData?.[payload.id]
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgetFilterData: {
            ...state.actualPage.widgetFilterData,
            widgetBeingEdited: filterData ? { ...filterData } : {},
          },
        },
      }
    case GET_WIDGET_DATA_SUCCESS:
      return getNewStateOnWidgetDataSuccess(state, payload)
    case GET_FIELD_INFOS_SUCCESS:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgetFilterData: {
            ...state.actualPage.widgetFilterData,
            [payload.widgetId]: payload.body,
          },
        },
      }
    case UPLOAD_WIDGET_IMAGE_PAGE_STATUS_RESET:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgetImageData: {
            ...state.actualPage.widgetImageData,
            widgetBeingEdited: {
              ...state.actualPage.widgetImageData.widgetBeingEdited,
              uploadStatus: "NONE",
            },
          },
        },
      }
    case UPLOAD_WIDGET_IMAGE_PAGE_STATUS_PENDING:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgetImageData: {
            ...state.actualPage.widgetImageData,
            widgetBeingEdited: {
              ...state.actualPage.widgetImageData.widgetBeingEdited,
              uploadStatus: "IN_PROGRESS",
            },
          },
        },
      }
    case UPLOAD_WIDGET_IMAGE_PAGE_STATUS_SUCCESS:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgetImageData: {
            ...state.actualPage.widgetImageData,
            widgetBeingEdited: {
              ...state.actualPage.widgetImageData.widgetBeingEdited,
              uploadStatus: "DONE",
            },
          },
        },
      }
    case RESET_PAGE_PROPS:
      return {
        ...state,
        actualPage: initialState?.actualPage,
      }
    case SET_WIDGET_REQUEST_STATUS:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          widgetsRequestStatus: {
            ...state.actualPage.widgetsRequestStatus,
            [payload.widgetId]: payload.status,
          },
        },
      }
    case SET_LAST_WIDGET_SAVED:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          lastWidgetSave: {
            widgetId: payload.widgetId,
            timestamp: Date.now(),
          },
        },
      }
    case CHANGE_SAVING_PAGE_STATUS:
      return {
        ...state,
        actualPage: {
          ...state.actualPage,
          pageInformations: {
            savingStatus: payload,
          },
        },
      }
    case SET_DRILLDOWN_ENABLED:
      return { ...state, drillDownEnabled: payload }
    default:
      return state
  }
}

export default pageReducer
